// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-xxl-container {
  .modal-xxl {
    max-width: 1600px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/modal-xxl.css"],"names":[],"mappings":"AAAA;EACE;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".modal-xxl-container {\n  .modal-xxl {\n    max-width: 1600px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
